import { api } from "../api/client.js";
import { navigate } from "../App.js";
import { Busy, ErrorNotice, useAsync } from "../lib/ui.js";
import { IntakeCard } from "./Cases.js";

/** 입고 접수 — 케이스 목록에서 떼어 낸 화면 (2026-09-09). 접수가 끝나면 목록으로 간다 */
export function Intake() {
  const companies = useAsync(() => api.companies(), []);
  return (
    <>
      <div className="admin-head">
        <span className="navicon" aria-hidden="true">⇩</span>
        <div>
          <h1>입고 접수</h1>
          <p className="page-desc" style={{ margin: 0 }}>
            시리얼을 여러 줄 붙여넣으면 정규화해 한 번에 접수합니다. 시리얼 뒤에 탭이나 공백 두 칸을 두고 증상을 적으면
            같이 저장됩니다.
          </p>
        </div>
      </div>
      <ErrorNotice error={companies.error} />
      {companies.loading ? (
        <Busy />
      ) : (
        <IntakeCard companies={companies.data ?? []} onDone={() => navigate("#/cases")} />
      )}
    </>
  );
}
